import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  copyright: {
    id: 'donater.footer.copyrights',
    defaultMessage: '© 2024 Streamiverse. All rights reserved.',
  },
})
